/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorChangeDayCount } from './ActorChangeDayCount';
import {
    ActorChangeDayCountFromJSON,
    ActorChangeDayCountFromJSONTyped,
    ActorChangeDayCountToJSON,
    ActorChangeDayCountToJSONTyped,
} from './ActorChangeDayCount';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface StudioActivityMonth
 */
export interface StudioActivityMonth {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof StudioActivityMonth
     */
    year: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof StudioActivityMonth
     */
    month: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<ActorChangeDayCount>}
     * @memberof StudioActivityMonth
     */
    days: Array<ActorChangeDayCount>;
}

/**
 * Check if a given object implements the StudioActivityMonth interface.
 */
export function instanceOfStudioActivityMonth(value: object): value is StudioActivityMonth {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    return true;
}

export function StudioActivityMonthFromJSON(json: any): StudioActivityMonth {
    return StudioActivityMonthFromJSONTyped(json, false);
}

export function StudioActivityMonthFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudioActivityMonth {
    if (json == null) {
        return json;
    }
    return {
        
        'year': ApiUserTasksGetPageParameterFromJSON(json['year']),
        'month': ApiUserTasksGetPageParameterFromJSON(json['month']),
        'days': ((json['days'] as Array<any>).map(ActorChangeDayCountFromJSON)),
    };
}

export function StudioActivityMonthToJSON(json: any): StudioActivityMonth {
    return StudioActivityMonthToJSONTyped(json, false);
}

export function StudioActivityMonthToJSONTyped(value?: StudioActivityMonth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': ApiUserTasksGetPageParameterToJSON(value['year']),
        'month': ApiUserTasksGetPageParameterToJSON(value['month']),
        'days': ((value['days'] as Array<any>).map(ActorChangeDayCountToJSON)),
    };
}

